import { atom } from "recoil";

export const createChargingPointDrawerState = atom({
  key: "createChargingPointDrawerState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
});
